import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import CustomLoader from '../common/CustomLoader';
import { drapcodeIcon } from '../../common/custom/icon-library';
import CreateFormForPlugin from '../../common/formElements/CreateFormForPlugin';

export default class ShowPluginRelatedForm extends Component {
  static propTypes = {
    projectOnBoard: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    currentPlugin: PropTypes.string.isRequired,
    projectId: PropTypes.string.isRequired,
  };

  componentDidMount(prevProps) {
    const { currentPlugin, projectId, version } = this.props;
    this.props.actions.fetchPluginForm({ code: currentPlugin, version, projectId });
  }

  componentDidUpdate(prevProps) {
    const { currentPlugin, projectId, projectOnBoard, version } = this.props;
    const { popularPluginForm } = projectOnBoard;
    if (Object.keys(popularPluginForm).includes(currentPlugin)) {
      return;
    }
    if (prevProps.currentPlugin !== currentPlugin) {
      this.props.actions.fetchPluginForm({ code: currentPlugin, version, projectId });
    }
  }

  createSchemaForPluginConfiguration = (fields) => {
    let schema = {};
    if (fields) {
      Object.entries(fields).forEach(([key, value]) => {
        schema[key] = value.value || value.value === false ? value.value : '';
      });
    }

    return schema;
  };

  prepareValidationForPluginConfiguration = (fields) => {
    let validationSchema = {};

    if (fields) {
      Object.keys(fields).forEach((field) => {
        const fieldDetail = fields[field];
        if (fieldDetail.required) {
          let yupDetail = '';
          if (fieldDetail.type === 'text' || fieldDetail.type === 'password') {
            yupDetail = Yup.string().required("Can't be blank");
          } else if (fieldDetail.type === 'number') {
            yupDetail = Yup.number().required("Can't be blank");
          } else if (fieldDetail.type === 'email') {
            yupDetail = Yup.string().email('Not a valid email').required("Can't be blank");
          }
          validationSchema[field] = yupDetail;
        }
      });
    }
    return Yup.object().shape(validationSchema);
  };

  handleSubmit = async (values, resetForm) => {
    const { projectOnBoard, currentPlugin, projectId, version } = this.props;
    resetForm();
    const formData = {
      pluginCode: currentPlugin,
      keystore: JSON.stringify(values),
      isEnabled: true,
      version,
      projectId: projectId,
    };
    this.props.saveCurrentPlugin(formData);
  };

  showCurrentPluginForm = () => {
    const { projectOnBoard, currentPlugin, projectId } = this.props;
    const { popularPluginForm, fetchPluginFormPending } = projectOnBoard;
    if (Object.keys(popularPluginForm).length === 0 || !currentPlugin) {
      return;
    }
    const currentPluginDetail = popularPluginForm[currentPlugin];
    if (!currentPluginDetail) {
      return;
    }
    const { name, fields, code } = currentPluginDetail;
    return (
      <div className="my-3">
        <div className="card">
          <div className="card-header card-header-text" data-background-color="drapcode-dark-blue">
            <h6 className="card-title pb-0 mb-0 text-capitalise">Configure</h6>
          </div>
          <div className="card-content">
            <div className="row mx-auto">
              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <div className="mt-4">
                  <Formik
                    initialValues={this.createSchemaForPluginConfiguration(fields)}
                    validationSchema={this.prepareValidationForPluginConfiguration(fields)}
                    onSubmit={(values, { setSubmitting, resetForm }) => {
                      this.handleSubmit(values, resetForm);
                      setSubmitting(false);
                    }}
                  >
                    <Form className="form-horizontal">
                      {fields && !_.isEmpty(fields) ? (
                        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                          {Object.keys(fields).map((key, index) => (
                            <CreateFormForPlugin key={key} name={key} field={fields[key]} />
                          ))}
                        </div>
                      ) : (
                        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                          <h4>
                            <i className={`wb ${drapcodeIcon('info')}`}></i> Please click the
                            Install Plugin button.
                          </h4>
                        </div>
                      )}

                      <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 text-right">
                        <button type="submit" className="btn btn-theme-submit">
                          <i className={`wb ${drapcodeIcon('install')}`}></i>
                          &nbsp;Save Configuration&nbsp;
                          <CustomLoader loading={fetchPluginFormPending} />
                        </button>
                      </div>
                    </Form>
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { currentPlugin, projectOnBoard } = this.props;
    const { fetchPluginFormPending } = projectOnBoard;
    return (
      <div className="border-bottom border-top">
        {fetchPluginFormPending && <p>Loading Plugin Form Please Wait</p>}
        {!fetchPluginFormPending && this.showCurrentPluginForm()}
      </div>
    );
  }
}
